export default function ShadeColorToHex(c) {
  switch(c) {
  case 'black':
    return '#2a222c';
  case 'brown':
    return '#4c251d';
  case 'red':
    return '#ad3119';
  case 'strawberry blonde':
    return '#d4a572';
  case 'blonde':
    return '#f2e1b3';
  default:
    return '#eeeeee';
  }
}
